/* tslint:disable:object-literal-shorthand */
import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ExgApplicationTab, IExgTab} from 'exc-tab-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgDataListComponent, ExgModalService, ExgOverlayService, ExgTabComponent, ExgTabComponentHeaderElement} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ApplicationService} from '../../services/application.service';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {DataService} from '../../services/data.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {ExcSecurityService} from 'exc-security-v2';
import {BehaviorSubject, Observable} from 'rxjs';
import {TaskDataService} from '../../services/task-data.service';
import {CalculationVersionComponent} from '../../Calculation/calculation-version/calculation-version.component';

@Component({
  selector: 'app-task-workspace',
  templateUrl: './task-workspace.component.html',
  styles: []
})
export class TaskWorkspaceComponent extends ExcTranslation implements OnInit, IExgTab, IExgEvent {
  @ViewChild('VCrightTabControl', {read: ExgTabComponent}) VCrightTabControl!: ExgTabComponent;

  @ViewChild('DivDetails', {read: ElementRef}) DivDetails!: ElementRef;
  @ViewChild('DivDetails2', {read: ElementRef}) DivDetails2!: ElementRef;
  @ViewChild('DivSchedule', {read: ElementRef}) DivSchedule!: ElementRef;
  @ViewChild('DivVerlauf', {read: ElementRef}) DivVerlauf!: ElementRef;

  @ViewChild('VCVorganglist', {read: ExgDataListComponent}) VCVorganglist!: ExgDataListComponent;
  @ViewChild('PhotoDocList', {read: ExgDataListComponent}) PhotoDocList!: ExgDataListComponent;

  Events = new ExgApplicationEventEmitter();
  dataSummaryLoaded = new BehaviorSubject(false);

  Data: any;
  tabinstance: any;
  vorgCHK = 0;

  rightDrawerVisible = false;
  rightTabs: ExgTabComponentHeaderElement[] = [];
  init = true;
  workFlowMenu: any[] = [];

  //#region TaskSummary
  TaskSummary: ITaskSummaryData | any = this.dataSvc.Task.Summary.Get();
  config = {
    receiptList: {
      treeControl: new NestedTreeControl<any>(node => node.receipts),
      selectKey: 'rcptID',
      state: 1,
      selectedRow: undefined as any,
      uiFilter: [
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Neu',
          filterCondition: {operator: '=', value: 1},
          uiName: 'Neu',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'In Bearbeitung',
          filterCondition: {operator: '=', value: 2},
          uiName: 'InBearbeitung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Zur Prüfung',
          filterCondition: {operator: '=', value: 3},
          uiName: 'ZurPrüfung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'In Prüfung',
          filterCondition: {operator: '=', value: 4},
          uiName: 'InPrüfung',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'freigegeben',
          filterCondition: {operator: '=', value: 10},
          uiName: 'fertiggemeldet',
          uiValue: false
        },
        {
          filterType: 1,
          filterGroup: 'Status',
          filterField: 'rcpt_enmIdent_ReceiptStatus',
          uiCaption: 'Abgelehnt',
          filterCondition: {operator: '=', value: 20},
          uiName: 'Abgelehnt',
          uiValue: false
        }],
      uiSort: [
        {
          sortField: 'rcptCRD', sortDefault: 0, uiCaption: 'letzte Erstellung',
          uiValue: false
        },
        {
          sortField: 'rcptLCD', sortDefault: 0, uiCaption: 'letzte Änderung',
          uiValue: true
        }],
      isLoading: true,
      ready: () => {
        if (!this.TaskSummary?.receiptList?.data || this.TaskSummary?.receiptList?.data.length === 0) {
          this.config.receiptList.state = 2;
          // this.VCreceiptList.selectedRow = -1;
        } else {
          this.config.receiptList.state = 0;
          // this.VCreceiptList.selectedRow = 0;
        }
        this.config.receiptList.isLoading = false;
      },
      hasChild: (_: number, node: any): boolean => {
        return !!node.receipts && node.receipts.length > 0;
      },
      deleteReceipt: (rcptID: any, rcptUPT: any, rcptState: number) => {
        const SELF = this;

        if (rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
          SELF.modal.showSimple(
            this.getRessource('DeleteReceipt.Title'),
            this.getRessource('DeleteReceipt.Message'),
            true,
            true,
            this.getGlobal('Delete'),
            this.getGlobal('Cancel'),
          ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              SELF.config.receiptList.state = 1;
              SELF.config.receiptList.isLoading = true;
              SELF.excRest
                .delete(
                  SELF.excRest.computeUrl('ReceiptD', {rcptID}), {rcptUPT}, {})
                .subscribe(
                  (ret: any) => {
                    if (ret) {
                      if (ret) {
                        this.modal
                          .showToast(
                            ret.success
                              ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                              : this.getGlobal('Cancel')
                            , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                            , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');
                      }
                      this.Events?.Receipt?.List?.Deleted?.emit({success: ret});
                    }
                  }
                );
            }
          });
        }
      }
    },
    flowTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.flowTable.data || this.TaskSummary?.flowTable.data.length === 0) {
          this.config.flowTable.state = 2;
        } else {
          this.config.flowTable.state = 0;
        }
      },
    },
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.attachmentJagTable.data || this.TaskSummary?.attachmentJagTable?.isEmpty) {
          this.config.attachmentJagTable.state = 2;
        } else {
          this.config.attachmentJagTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    },
    worklist: {
      selectedRow: undefined as any,
      selectKey: 'apiID',
      selectionChanged: (index: number) => {
        this.config.worklist.selectedRow =
          this.TaskSummary?.workList?.data[index];
      },
    },
    taskList: {
      selectedObjects: [] as any[],
      rowChange: (index: number) => {
        if (!this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects = [];
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        } else {
          this.VCVorganglist.selectedRow = -1;
          this.config.taskList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects =
            this.config.taskList.selectedObjects.filter((sOrt: any) => sOrt !== this.TaskSummary?.taskList?.data[index]);
        } else {
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        }
      },
    },
    photoDocumentation: {
      selectedObjects: [] as any[],
      isLoading: false,
    },

    getOEByID: (ID: string): any => {
      return ExcCoreModule.Array.GetObject(this.TaskSummary?.oeList?.data, 'oeID', ID);
    },

    newMessage: (): void => {
      this.appSvc.Message.NewForTask.OpenTab({objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    newDefaultMessage: (dmsgID: any): void => {
      this.appSvc.Message.NewForTask.OpenTab({objID: this.TaskSummary?.ID, dmsgID: dmsgID}, {Events: this.Events});
    },

    newReport: (): void => {
      this.appSvc.Report.New(this.TaskSummary?.ID, {Events: this.Events});
    },

    newNote: (): void => {
      this.appSvc.Note.OpenModal({ntz_objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    showUploadReceiptModal: (): void => {
      this.appSvc.Receipt.Upload.OpenModal({rcpt_vorgID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    showHistory: (): void => {
      this.appSvc.History.OpenModal(this.TaskSummary?.historyTable?.data);
    },
    showAttachmentUploadModal: (): void => {
      this.appSvc.Document.Upload.OpenModal({dok_objID: this.TaskSummary?.ID}, {Events: this.Events});
    },

    documentTemplateDownload: (dotID: string): void => {
      this.appSvc.DocumentTemplate.Download(this.TaskSummary?.ID, dotID);
      this.TaskSummary?.LoadSummary();
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.TaskSummary?.ID, attID: dokID}, {Events: this.Events});
    },

    openCheckViewCollection: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenCollectionTab({
          rcptID:
            this.config.receiptList.selectedRow[
              this.config.receiptList.selectKey
              ],
        });
      }
    },

    onDblClickCheckView: (index: number): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.TaskSummary?.receiptList?.data[index].rcptID
        );
      }
    },

    openCheckView: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.config?.receiptList?.selectedRow?.rcptID
        );
      }
    },

    receiptCaseOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0) {
        this.appSvc.Receipt.Reporting.openCaseReport(
          this.TaskSummary?.caseDetails?.data?.auID,
          true
        );
      }
    },

    receiptTaskOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0) {
        this.appSvc.Receipt.Reporting.openTaskReport(this.TaskSummary?.ID, true);
      }
    },

    downloadPhotoDocumentation: (pdID: string): void => {
      this.config.photoDocumentation.isLoading = true;
      this.appSvc.PhotoDocumentation.Download(pdID, {Events: this.Events});
    }
  };
  resized = false;
  userType: number | any;
  showApiDivTable = true;

  //#endregion TaskSummary

  //#region VorgangsEditierung
  editFunctions = {
    editMode: false,
    editTaskModel: {
      vorgID: '',
      vorg_enmIdent_VorgangTyp: 0,
      vorg_enmName_VorgangTyp: '',
      vorgVorgangSubTyp_enmIdent: 0,
      vorgVorgangSubTyp_enmName: '',
      vorgBeschreibung: '',
      vorgUPT: ''
    } as { [key: string]: any },
    resetEditTaskModel(originalTaskModel: any): void {
      this.editTaskModel = {
        vorgID: '',
        vorg_enmIdent_VorgangTyp: 0,
        vorg_enmName_VorgangTyp: '',
        vorgVorgangSubTyp_enmIdent: 0,
        vorgVorgangSubTyp_enmName: '',
        vorgBeschreibung: '',
        vorgUPT: ''
      };
      for (const key in this.editTaskModel){
        /* Copy every relevant attribute^ to Model*/
        if (originalTaskModel[key] !== undefined) { this.editTaskModel[key] = originalTaskModel[key]; }
      }
    },
    compareEditTaskModels(originalTaskModel: any): boolean {
      for (const key in this.editTaskModel) {
        if (originalTaskModel[key] !== this.editTaskModel[key]) {
          return true; // Wenn ein Unterschied gefunden wurde, geben Sie true zurück
        }
      }
      return false; // Wenn kein Unterschied gefunden wurde, geben Sie false zurück
    },
    enterEditMode(originalTaskModel: any): void {
      this.resetEditTaskModel(originalTaskModel);
      this.editMode = true;
      },
    cancelEdit(originalTaskModel: any): void {
      this.resetEditTaskModel(originalTaskModel);
      this.editMode = false;
    }
  };
  private _selectedVorgangTypIndex = 0;
  get selectedVorgangTypIndex(): number {
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map(a => (a.enmIdent));
    const currentIdent = this.editFunctions.editTaskModel.vorg_enmIdent_VorgangTyp;
    return enumListIdents.indexOf(currentIdent);
  }
  set selectedVorgangTypIndex(selectedIndex: number) {
    /*change the Model displayed to the selected Type*/
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map( a => (a.enmIdent));
    this._selectedVorgangTypIndex = selectedIndex;
    this.editFunctions.editTaskModel.vorg_enmIdent_VorgangTyp = enumListIdents[selectedIndex];
    /*the selected Type influences the subtype select with enmSelector = enmName*/
    const enumSelectorList =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp).map( a => (a.enmSelector));
    if (this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName !== enumSelectorList[selectedIndex]) {
      this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmName = enumSelectorList[selectedIndex];
      this.selectedVorgangSubTypIndex = 0;
    }
  }
  private _selectedVorgangSubTypIndex = 0;
  get selectedVorgangSubTypIndex(): number {
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName).map(a => (a.enmIdent));
    const currentIdent = this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmIdent;
    return enumListIdents.indexOf(currentIdent);
  }
  set selectedVorgangSubTypIndex(selectedIndex: number) {
    const enumListIdents =
      this.enumSvc.getEnumerationList(this.editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName).map( a => (a.enmIdent));
    this._selectedVorgangSubTypIndex = selectedIndex;
    this.editFunctions.editTaskModel.vorgVorgangSubTyp_enmIdent = enumListIdents[selectedIndex];
  }
  constructor(public excRest: ExcRestService,
              public modal: ExgModalService,
              private overlaySrv: ExgOverlayService,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService,
              private dataSvc: DataService,
              public excSecurity: ExcSecurityService,
              private renderer: Renderer2,
              private taskDataSvc: TaskDataService) {
    super();
    this.registerEvents();
    this.initialize();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.tabinstance.Active) {
        this.TaskSummary?.LoadSummary();
      }
      this.changeApiDiv();
    });
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.tabinstance.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    this.dataSummaryLoaded.subscribe(async (temp) => {
      const SELF = this;
      if (temp) {
        await new Promise(f => setTimeout(f, 250));
      }
      this.setVerlaufHeight();
      this.changeApiDiv();
      this.apiWarnings();
    });
    this.Events.Message?.NewForTask?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.NoteDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.List?.Deleted?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UpdateDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.Preview?.Downloaded?.subscribe((evt: ExgEventArgs) => {
      this.config.receiptList.isLoading = false;
    });
    this.Events.Schedule?.UpdateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Schedule?.CreateSchedule?.Closed?.subscribe(() => {
      this.init = true;
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.config.receiptList.ready();
        this.config.flowTable.ready();
        this.config.attachmentJagTable.ready();
        this.tabinstance.Label = this.TaskSummary?.taskDetails?.data?.vorgNr;
        this.init = false;
        this.dataSummaryLoaded.next(true);
        const SELF = this;
        SELF.workFlowMenu = [
          {
            // Vorgang speichern
            security: 'TASKEDIT',
            get caption(): string {
              return SELF.getResource('Workflow.Save');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // Vorgang geprüft markieren
            security: 'TASKCHECK',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCheck');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Check(SELF.TaskSummary?.taskDetails?.data).subscribe((response: any) => {
                if (response && response.success) {
                  SELF.TaskSummary.LoadSummary(response);
                }
              });
            }
          },
          {
            // Vorgang disponieren (Bearbeiter auswählen)
            security: 'TASKDISPO',
            get caption(): string {
              return SELF.getResource('Workflow.TaskAssign');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.changeEditor();
            }
          },
          {
            // Vorgang Editor entfernen (Bearbeiter entfernen)
            security: 'TASKDISPO',
            get caption(): string {
              return SELF.getResource('Workflow.TaskRemoveEditor');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.ChangeEditor(SELF.TaskSummary?.taskDetails?.data, '00000000-0000-0000-0000-000000000000')
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary();
                });
            }
          },
          {
            // Vorgang annehmen
            security: 'TASKACCEPT',
            get caption(): string {
              return SELF.getResource('Workflow.TaskAccept');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 2;
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Accept(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Vorgang ablehnen
            security: 'TASKDECLINE',
            get caption(): string {
              return SELF.getResource('Workflow.TaskDecline');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 2;
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.Decline(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Vorgang fertig melden
            security: 'TASKFINISH',
            get caption(): string {
              return SELF.getResource('Workflow.TaskFinish');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (
                        SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 4
                        || SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus === 14
                      );
              }
              return this._visible;
            },
            click: (): void => {
              this.taskStateChange({
                title: 'Vorgang: fertig melden',
                message: 'Nach dem angeforderten Statuswechsel ist der Vorgang nur noch eingeschränkt bearbeitbar. Sind Sie sicher, dass Sie den Vorgang fertig melden möchten?',
                actions: [
                  {btnText: 'fertig melden', disabled: false, rtValue: true}
                ]
              }).subscribe((accepted: boolean) => {
                if (accepted) {
                  SELF.taskDataSvc.Task.Finish(SELF.TaskSummary?.taskDetails?.data)
                    .subscribe((response: any) => {
                      SELF.TaskSummary?.LoadSummary(response);
                    });
                }
              });
            }
          },
          {
            // Vorgang stornieren
            security: 'TASKCANCEL',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCancel');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              const task = SELF.TaskSummary.taskDetails.data;
              const enumList = SELF.enumSvc.getEnumerationList('VorgangStatus');

              const cancelStatusEnum = enumList.filter((e: any) => e.enmIdent === 9);

              if (task && cancelStatusEnum?.length > 0) {
                SELF.modal.show('ModalTaskStateChangeCommentComponent', {
                  taskState: 9,
                  enums: cancelStatusEnum,
                  isCancelOnly: true
                }).subscribe((modalResponse: any) => {
                  if (modalResponse && modalResponse.selectedStateEnmIdent) {
                    SELF.taskDataSvc.Task.ManualStateChange(
                      SELF.TaskSummary.taskDetails.data,
                      modalResponse.selectedStateEnmIdent,
                      modalResponse.stateChangeComment
                    ).subscribe(() => {
                      SELF.TaskSummary?.LoadSummary();
                      SELF.modal.showToast(
                        'Vorgang storniert',
                        'md-toast bg-green',
                        'fas fa-check-circle'
                      );
                    });
                  }
                });
              }
            }
          },
          {
            // Vorgang sperren
            security: 'VORGL',
            get caption(): string {
              return SELF.getResource('Workflow.TaskLock');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && false;
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // Ablaufplan erstellen
            security: 'SCHEDULEINIT',
            get caption(): string {
              return SELF.getResource('Workflow.TaskCreateAP');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.InitSchedule(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Dokumentenmanagement
            security: 'DOCUMENTMGMT',
            get caption(): string {
              return SELF.getResource('Workflow.DocumentManagement');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && false;
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // An Exakt:App senden (Motionscloud)
            security: 'TASK2APP',
            get caption(): string {
              return SELF.getResource('Workflow.SendToExaktApp');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.SendToApp(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary(response);
                });
            }
          },
          {
            // Fragen beantworten
            security: '',
            get caption(): string {
              return SELF.getResource('Workflow.AnswerQuestions');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && (!SELF.TaskSummary || SELF.TaskSummary?.dialogueQuestions?.data?.length > 0);
              }
              return this._visible;
            },
            click(): void {
              SELF.openDialogueQuestions();
            }
          },
          {
            // QS-Regulierungsvereinbarung/Kurzbericht abschließen
            security: 'DOKMGMT',
            get caption(): string {
              return SELF.getResource('Workflow.QSFinish');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
                  && SELF.TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp === 24;
              }
              return this._visible;
            },
            click(): void {
            }
          },
          {
            // Kontaktaufnahmeversuch
            security: 'TASKCONTATTEMPT',
            get caption(): string {
              return SELF.getResource('Workflow.ContactAttempt');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.modal.show('ModalContactAttemptComponent', {
                taskId: SELF.TaskSummary?.taskDetails?.data?.vorgID,
                caseId: SELF.TaskSummary?.caseDetails?.data?.auID
              }).subscribe((modalResult: any) => {
                if (modalResult && modalResult.success) {
                  SELF.taskDataSvc.Task.ContactAttempt(
                    SELF.TaskSummary?.taskDetails?.data,
                    SELF.TaskSummary?.caseDetails?.data,
                    {
                      contactDateTime: modalResult.contactDateTime,
                      comment: modalResult.comment
                    }
                  ).subscribe((response: any) => {
                    if (response && response.success) {
                      SELF.TaskSummary?.LoadSummary();
                      SELF.modal.showToast(
                        SELF.getRessource('ContactAttempt.Success'),
                        'md-toast bg-green',
                        'fas fa-check'
                      );
                    } else {
                      SELF.modal.showToast(
                        SELF.getRessource('ContactAttempt.Failed'),
                        'md-toast bg-red',
                        'fas fa-exclamation'
                      );
                    }});
                }});
            }
          },
          {
            // An mich disponieren
            security: 'TASKDISPO2ME',
            get caption(): string {
              return SELF.getResource('Workflow.AssignToMe');
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click(): void {
              SELF.taskDataSvc.Task.DispoToMe(SELF.TaskSummary?.taskDetails?.data)
                .subscribe((response: any) => {
                  SELF.TaskSummary?.LoadSummary();
                });
            }
          },
          {
            // Status manuell ändern
            security: 'TASKSTATCHANGE',
            get caption(): string {
              return 'Status manuell ändern';
            },
            get visible(): boolean {
              if (this._visible === undefined) {
                this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
              }
              return this._visible;
            },
            click: (): void => {
              this.openTaskStateModal();
            },
          }/*,
      {
        // Editieren
        security: '*',
        get caption(): string {
          return SELF.getResource('Workflow.EditFields');
        },
        get visible(): boolean {
          return ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security)
        },
        click(): void {
          SELF.editMode = true;
        }
      }*/
        ];
      }
    });
    this.Events.DialogueQuestion.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        const x = evt.data.find((e: any) => {
          return e.dfPflichtfeld && (!e.deValue || e.deValue === '');
        });
        if (this.init && x) {
          this.openDialogueQuestions();
        }
      }
    });
    this.Events.Questionnaire?.CreateUpdateVersion?.Closed?.subscribe( (ret: any) => {
      if (ret?.success) {
        this.TaskSummary?.LoadSummary();
      }
    });
    this.Events.PhotoDocumentation?.Download?.Finished?.subscribe( (ret: any) => {
      if (ret?.success) {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download erfolgreich', 'md-toast', 'fas fa-check');
        }
      else {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
      }
    });
  }

  initialize(): void {
    const SELF = this;
    SELF.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DOCUMENTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Task.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Task.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.DialogueQuestions.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.DialogueQuestions.Icon');
        }
      },
      {
        get caption(): string {
          return 'Bilddokumentation';
        },
        get icon_class(): string {
          return 'fa fa-file-image';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.CalcVersion.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.CalcVersion.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      /*{
        get caption(): string {
          return 'Fragebögen';
        },
        get icon_class(): string {
          return 'fa fa-list-ol';
        }
      },*/
    ];
  }

  /* Lifecycle Hooks*/
  ngOnInit(): void {
    this.TaskSummary = this.dataSvc.Task.Summary.Get(this.Data, undefined, {Events: this.Events});
  }

  //#region TaskWorkspace
  changeEditor(): void {
    this.overlaySrv.show(
      'OverlayDispositionComponent', {vorgID: this.TaskSummary?.ID}, true
      ).subscribe((ret: any) => {
        if (ret && ret.assigned) {
          this.TaskSummary?.LoadSummary();
        }
      });
  }

  changeCoEditor(): void {
    const SELF = this;
    SELF.excRest.get(SELF.excRest.computeUrl('OeR_List_User')).subscribe(
      (response: any) => {
        if (response) {
          this.modal.show('ModalCoEditorComponent', response.data).subscribe((modalResponse: any) => {
            if (modalResponse) {
              SELF.excRest.put(SELF.excRest.computeUrl('TaskU_CoEditor',
                  {oeID: modalResponse.oeID, vorgID: SELF.TaskSummary?.ID}),
                modalResponse)
                // tslint:disable-next-line:no-shadowed-variable
                .subscribe((response: any) => {
                  if (response.success) {
                    this.TaskSummary?.LoadSummary();
                    this.modal.showToast(
                      SELF.getRessource('ChangeCoEditor.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  } else {
                    this.modal.showToast(
                      SELF.getRessource('ChangeCoEditor.Fail')
                      , 'md-toast', 'fas fa-exclamation');
                  }
                });
            }
          });
        }
      }
    );
  }

  deleteCoEditor(): void {
    this.modal.showSimple(this.getRessource('ChangeCoEditor.RemoveTitle')
      , this.getRessource('ChangeCoEditor.RemoveQuestion')
      , true, true
      , this.getRessource('ChangeCoEditor.Remove')
      , this.getGlobal('Cancel')
    ).subscribe(
      (response: any) => {
        if (response) {
          this.excRest.put(this.excRest.computeUrl('TaskU_CoEditor',
            {oeID: '00000000-0000-0000-0000-000000000000', vorgID: this.TaskSummary?.ID}),
          response)
          .subscribe((response2: any) => {
            if (response2.success) {
              this.TaskSummary?.LoadSummary();
              this.modal.showToast(
                this.getRessource('ChangeCoEditor.RemoveSuccess')
                , 'md-toast', 'fas fa-check-circle');
            } else {
              this.modal.showToast(
                this.getRessource('ChangeCoEditor.RemoveFail')
                , 'md-toast', 'fas fa-exclamation');
            }
          });
        }
      }
    );
  }

  showWorklistUpdateModalWithRow(row: any): void {
    if (this.excSecurity.isFeatured('SCHEDULEEDIT') && row) {
      this.appSvc.Schedule.Update.OpenModal({
        worklistData: this.TaskSummary?.workList?.data, worklistItem: row
      }, {Events: this.Events});
    }
  }

  showWorklistUpdateModal(index: number): void {
    if (this.excSecurity.isFeatured('SCHEDULEEDIT')) {
      this.appSvc.Schedule.Update.OpenModal({
        worklistData: this.TaskSummary?.workList?.data, worklistItem: this.TaskSummary?.workList?.data[index]
      }, {Events: this.Events});
    }
  }

  showObjectImageUpdateModal(): void {
    this.appSvc.Document.Preview.OpenModal({
      objID: this.TaskSummary?.ID,
      attID: this.TaskSummary?.caseDetails?.data?.aueObjektbild_dokID,
      CustomAction: {
        caption: this.getResource('caption'),
        click: (item: any) => {
          if (item) {
            const data = {aueObjektbild_dokID: item.dokID};
            this.excRest.put(this.excRest.computeUrl('CaseU_ObjectPic', {auID: this.TaskSummary?.caseDetails?.data.auID})
              , data).subscribe((response: any) => {
              if (response.success) {
                this.TaskSummary?.LoadSummary();
                this.modal.showToast(
                  this.getRessource('ChangeObjectPic.Success'),
                  'md-toast', 'fas fa-check-circle');
              } else {
                this.modal.showToast(
                  this.getRessource('ChangeObjectPic.Fail'),
                  'md-toast', 'fas fa-check-circle');
              }
            });
          }
        }
      },
      allowedMIME: ['image/*']
    }, {Events: this.Events});
  }

  openDialogueQuestions(): void {
    this.appSvc.DialogueQuestion.OpenModal(
      {vorgID: this.TaskSummary?.ID, questions: this.TaskSummary?.dialogueQuestions.data},
      {Events: this.Events});
  }

  isWorkflowActive(): boolean {
    return this.workFlowMenu.findIndex(e => e.visible) !== -1;
  }

  createNewTaskWorklist(): void {
    if (this.excSecurity.isFeatured('SCHEDULECREATE')) {
      this.appSvc.Schedule.Create.OpenModal(
        {worklistData: this.TaskSummary?.workList?.data, taskID: this.TaskSummary?.ID}
        , {Events: this.Events}
      );
    }
  }

  setVerlaufHeight(): void {
    const DivDetails = this.DivDetails?.nativeElement.getBoundingClientRect();
    const DivDetails2 = this.DivDetails2?.nativeElement.getBoundingClientRect();
    if (DivDetails !== undefined && DivDetails2 !== undefined) {
      const height = DivDetails.height >= DivDetails2.height ? DivDetails.height : DivDetails2.height;

      this.renderer.setStyle(this.DivVerlauf.nativeElement, 'height', `${height}px`);
      this.resized = true;
    }
  }

  taskStateChange(
    modalData: {
      title: string,
      message: string,
      actions: [{
        btnText: string, disabled: false
        rtValue: boolean
      }]
    }): Observable<any> {
    if (!this.excSecurity.isFeatured('TASKSTATCHANGE')) {
      modalData.title =
        this.getRessource(modalData.title).startsWith('TaskWorkspaceComponent') ?
          modalData.title
          : this.getRessource(modalData.title);
      modalData.message =
        this.getRessource(modalData.message).startsWith('TaskWorkspaceComponent') ?
          modalData.message
          : this.getRessource(modalData.message);
      modalData.actions
        .forEach((btn: any) => {
          if (!this.getRessource(btn.btnText).startsWith('TaskWorkspaceComponent')) {
            btn.btnText = this.getRessource(btn.btnText);
          }
        });
      return this.modal.show('ModalTaskStateChangeComponent', modalData);
    }
    return new Observable(observer => {
      observer.next(true);
    });
  }

  openCase(): void {
    if (!this.excSecurity.isFeatured('CASEREAD')) {
      return;
    }
    this.appSvc.Case.Workspace.OpenTab(this.TaskSummary.taskDetails.data.vorg_auID);
  }

  OpenDetailHistoryModal(): void {
    if (!this.TaskSummary.isLoading) {
      this.modal
        .show('ModalDetailHistoryComponent', {ID: this.TaskSummary?.ID, Object: this.TaskSummary.taskDetails.data})
        .subscribe(() => {
        });
    }
  }

  openFileOverview(): void {
    this.appSvc.Document.Manager.OpenOverlay({vorgID: this.TaskSummary?.ID, Events: this.Events});
  }

  changeLastQSAuditor(): void {
    const SELF = this;

    SELF.excRest.get(SELF.excRest.computeUrl('OeR_List_User')).subscribe(
      (response) => {
        if (response) {
          this.modal.show('ModalCoEditorComponent', response.data).subscribe((modalResponse: any) => {
            if (modalResponse) {
              SELF.excRest.put(SELF.excRest.computeUrl('CaseU_LastQSAuditor',
                  {oeID: modalResponse.oeID, auID: SELF.TaskSummary?.caseDetails?.data?.auID}),
                modalResponse)
                // tslint:disable-next-line:no-shadowed-variable
                .subscribe((response: any) => {
                  if (response.success) {
                    this.TaskSummary?.LoadSummary();
                    this.modal.showToast(
                      SELF.getRessource('ChangeLastQSAuditor.Success')
                      , 'md-toast', 'fas fa-check-circle');
                  } else {
                    this.modal.showToast(
                      SELF.getRessource('ChangeLastQSAuditor.Fail')
                      , 'md-toast', 'fas fa-exclamation');
                  }
                });
            }
          });
        }
      }
    );
  }

  changeApiDiv(): void {
    const DivWidth = this.DivDetails?.nativeElement.getBoundingClientRect();
    if (DivWidth !== undefined) {
      this.showApiDivTable = DivWidth.width >= 520;
    }
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTab(task.vorgID);
    }
  }

  apiWarnings(): void {
    if (this.TaskSummary?.workList?.data && this.TaskSummary?.workList?.data.length > 0) {
      for (const apiListElement of this.TaskSummary?.workList?.data) {
        Object.assign(apiListElement, {
          apiSollDatumWTooltip: '',
          apiPlanDatumWTooltip: '',
          apiSollDatumShowWarning: false,
          apiPlanDatumShowWarning: false
        });

        if (this.excSecurity.isFeatured('SCHEDULESHOWESC')) {
          // Plandatum überschreitet Solldatum
          if (apiListElement.apiPlanDatum
            && apiListElement.apiSollDatum
            && apiListElement.apiPlanDatum > apiListElement.apiSollDatum) {
            apiListElement.apiPlanDatumShowWarning = true;
            apiListElement.apiPlanDatumWTooltip = this.getRessource('Ablaufplan.PlanSolldatum');
          }

          // Solldatum überschritten
          if (apiListElement.apiSollDatum
            && new Date(apiListElement.apiSollDatum) < new Date()) {
            apiListElement.apiSollDatumShowWarning = true;
            apiListElement.apiSollDatumWTooltip = this.getRessource('Ablaufplan.HeuteSolldatum');
          }

          // Vorgangsfrist überschritten
          if (apiListElement.apiSollDatum
            && new Date(apiListElement.apiSollDatum) > new Date(this.TaskSummary?.taskDetails?.data?.vorgFrist)) {
            if (apiListElement.apiSollDatumShowWarning) {
              apiListElement.apiSollDatumWTooltip += '\n\r';
            } else {
              apiListElement.apiSollDatumShowWarning = true;
            }
            apiListElement.apiSollDatumWTooltip += this.getRessource('Ablaufplan.FristSolldatum');
          }
        }
      }
    }
  }
  saveEdit(originalTaskModel: any): void {
    if (this.excSecurity.isFeatured('TASKEDIT')) {
      const modelChanged = this.editFunctions.compareEditTaskModels(originalTaskModel);
      if (modelChanged) {
        this.taskDataSvc.Task.Edit(this.editFunctions.editTaskModel).subscribe((updated: any) => {
          if (updated) {
            this.TaskSummary?.LoadSummary();
            this.modal.showToast(
              this.getRessource('SaveEdit.Success')
              , 'md-toast', 'fas fa-check-circle');
            this.editFunctions.editMode = false;
          }
          else {
            this.modal.showToast(
              this.getRessource('SaveEdit.Failed')
              , 'md-toast', 'fas fa-exclamation');
            this.editFunctions.editMode = false;
          }
        });
      }
      else {
        this.editFunctions.editMode = false;
      }
    }
  }

  /*change($event: { index: number; value: any }): void  {
    const enmList = $event.value.enmName;
    this.TaskSummary.loadData();
  }*/
  openTaskStateModal(): void {
    if (this.excSecurity.isFeatured('TASKSTATCHANGE')) {
      const task = this.TaskSummary.taskDetails.data;
      const enumList = this.enumSvc.getEnumerationList('VorgangStatus');
      /**/
      if (task && enumList?.length > 0) {
        this.modal.show('ModalTaskStateChangeCommentComponent', {taskState: task.vorg_enmIdent_VorgangStatus, enums: enumList})
          .subscribe((modalResponse: any) => {
            if (modalResponse && task.vorg_enmIdent_VorgangStatus !== modalResponse.selectedStateEnmIdent){
              /*different State was selected*/
              if (task.vorg_enmIdent_VorgangStatus !== modalResponse.selectedStateEnmIdent) {
                this.taskDataSvc.Task.ManualStateChange(this.TaskSummary.taskDetails.data
                                                      , modalResponse.selectedStateEnmIdent
                                                      , modalResponse.stateChangeComment)
                .subscribe(() => {
                  this.TaskSummary?.LoadSummary();
                  this.modal.showToast(
                    this.getRessource('StateChange.Success')
                    , 'md-toast', 'fas fa-check-circle');
                });
              }
              /*no Response from Modal*/
            } else if (modalResponse && task.vorg_enmIdent_VorgangStatus === modalResponse.selectedStateEnmIdent) {
              this.modal.showToast(
                this.getRessource('StateChange.NoChange')
                , 'md-toast', 'fas fa-exclamation');
            }
          });
      }
    }
  }

  createNewQuestionnaireVersion(id: any): void {
    const data = { vorgID: this.TaskSummary?.ID, qcnfID: id};
    this.appSvc.QuestionnaireVersion.OpenModal(data, {Events: this.Events});
  }


  createNewPhotoDoc(): void {
    this.appSvc.Task.PhotoDocumentation.OpenTab(
      { FKID: this.TaskSummary.taskDetails.data.vorgID, aueSchadenNr: this.TaskSummary.caseDetails.data.aueSchadenNr},
      {Events: this.Events}
    );
  }
  openExistingPhotoDoc(pd: { pdID: string; pdData: string; pdDescription: string;
                             pdPhotoDocumentationStatus_enmIdent: number;
                             pdName: string; pdUPT: string; [p: string]: any }): void {
    this.appSvc.Task.PhotoDocumentation.OpenTab(
      { FKID: this.TaskSummary.taskDetails.data.vorgID, pdData: pd.pdData, pdID: pd.pdID, pdDescription: pd.pdDescription
        , pdPhotoDocumentationStatus_enmIdent: pd.pdPhotoDocumentationStatus_enmIdent, pdName: pd.pdName, pdUPT: pd.pdUPT
        , aueSchadenNr: this.TaskSummary.caseDetails.data.aueSchadenNr},
      {Events: this.Events}
    );
  }

  openPhotoDocEditTextModal(isUpload: boolean = false, editModel: any = {}): void {
    this.modal.show('ModalFinishPhotoDocComponent', { isUpload, editModel }).subscribe( (rslt: any) => {
      if ( rslt ) {
        const url = this.excRest.computeUrl('PhotoDocumentationU', {pdID: editModel.pdID});
        const uiModel: any = {
          pdName: rslt.pdName,
          pdUPT: editModel.pdUPT,
          pdDescription: rslt.pdDescription,
          pdPhotoDocumentationStatus_enmIdent: rslt.pdPhotoDocumentationStatus_enmIdent
        };
        this.excRest.put(url, uiModel).subscribe((res: any) => {
          if (res?.success) {
            this.modal.showToast(
              'Datenänderung erfolgreich!'
              , 'md-toast', 'fas fa-check');
            this.TaskSummary?.LoadSummary();
          }
          else {
            this.modal.showToast('Datenänderung fehlgeschlagen!', 'md-toast', 'fas fa-exclamation');
          }
        });
      }
    });
  }

  deletePhotoDoc(deleteModel: any = {}): void {
    this.modal.showSimple( 'Bilddokumentation löschen'
      , 'Möchten Sie diese Bilddokumentation wirklich löschen?'
      , true, true, 'Ja, löschen', 'Abbrechen')
      .subscribe((response: any) => {
        if (response && deleteModel.pdID) {
          const url = this.excRest.computeUrl('PhotoDocumentationD', {pdID: deleteModel.pdID});
          this.excRest.delete(url, {pdUPT: deleteModel.pdUPT}).subscribe((res: any) => {
            if (res?.success) {
              this.modal.showToast(
                'Datenlöschung erfolgreich!'
                , 'md-toast', 'fas fa-check');
              this.TaskSummary?.LoadSummary();
            } else {
              this.modal.showToast('Datenlöschung fehlgeschlagen!', 'md-toast', 'fas fa-exclamation');
            }
          });
        }
      });
  }

  createNewCalculationVersion(row: any): void {
    const data = {cv_ctID: row.ctID, cv_fkID: this.TaskSummary.taskDetails.data.vorgID};

    if (row.cvID) {
      Object.assign(data, {cvID: row.cvID});
    }

    const tab = new ExgApplicationTab(
      row.cvName ?? row.ctName,
      CalculationVersionComponent,
      data,
      data.cv_ctID
    );
    tab.Open();
  }

  async openWorkspaceV2(index?: number): Promise<void> {
    this.appSvc.Task.Workspace.OpenTabV2(this.TaskSummary.taskDetails.data.vorgID, {Events: this.Events});
  }

}
